var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledDoubleLayerCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.9609,
    r: 16,
    fill: "#E7F6EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 28.2109C22.7132 28.2109 27.75 23.1741 27.75 16.9609C27.75 10.7477 22.7132 5.71094 16.5 5.71094C10.2868 5.71094 5.25 10.7477 5.25 16.9609C5.25 23.1741 10.2868 28.2109 16.5 28.2109ZM21.0943 15.3828C21.6034 14.9165 21.6381 14.1258 21.1718 13.6167C20.7055 13.1076 19.9149 13.0729 19.4057 13.5391L14.7907 17.7659L13.5943 16.6702C13.0852 16.2039 12.2945 16.2386 11.8282 16.7477C11.3619 17.2568 11.3966 18.0475 11.9057 18.5138L13.9464 20.3827C14.4242 20.8203 15.1571 20.8203 15.6349 20.3827L21.0943 15.3828Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledDoubleLayerCheck);
export default __webpack_public_path__ + "static/media/filled-double-layer-check.e5f797ba9072fc898e4030e989263082.svg";
export { ForwardRef as ReactComponent };